import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { toLower, trim } from 'lodash';
import { ScenarioPlannerResponseDto, ScenarioResponseDto } from '@app/shared/models/scenario-planner';

@Injectable({
  providedIn: 'root',
})
export class ScenarioPlannerService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getLampCatalogue(lampId: string, municipalityKey: string, grossElectricityCost: number, co2Emission: number): Observable<any> {
    return this.http.get(
      this.endpoint(
        `api`,
        `scenarioplanner`,
        `municipalityKey`,
        `${municipalityKey}`,
        `streetlightId`,
        `${lampId}`,
        'lampcatalogue',
        `?grossElectricityCost=${grossElectricityCost}&co2Emission=${co2Emission}`
      )
    );
  }

  public getByMunicipalityId(municipalityId: string): Observable<ScenarioResponseDto[]> {
    return this.http.get<ScenarioResponseDto[]>(this.endpoint(`api`, `scenarioplanner`, `municipalityId`, `${municipalityId}`));
  }

  public getById(id: string): Observable<ScenarioPlannerResponseDto> {
    return this.http.get<ScenarioPlannerResponseDto>(this.endpoint(`api`, `scenarioplanner`, id));
  }

  public post(scenario: any): Observable<string> {
    return this.http.post<string>(this.endpoint(`api`, `scenarioplanner`), scenario);
  }

  public put(id: string, scenario: any) {
    return this.http.put(this.endpoint(`api`, `scenarioplanner`, id), scenario);
  }

  public delete(id: string) {
    return this.http.delete(this.endpoint(`api`, `scenarioplanner`, id));
  }

  public submit(id: string) {
    return this.http.put(this.endpoint(`api`, `scenarioplanner`, id, `submitted`), {});
  }

  public getRecommendations(municipality: string, type: string, budget: string) {
    let typeId;
    switch (toLower(trim(type))) {
      case 'economical':
        typeId = 1;
        break;
      case 'sustainable':
        typeId = 2;
        break;
      case 'substance-renewal':
        typeId = 3;
        break;
    }

    return this.http.get(this.endpoint(`api/municipalities/${municipality}/scenarioplanner/recommendations/${typeId}?budget=${budget}`));
  }
}
